<template>
  <div class="styleCard">
    <ul class="style-nav style2">
      <li
        v-for="tab in repTabs"
        :key="tab.id"
        :class="{ active: selectedRepTab === tab.alias }"
        @click="selectedRepTab = tab.alias"
      >
        {{ tab.name }}
      </li>
    </ul>
    <campaigns v-if="selectedRepTab === 'CAMP'"></campaigns>
    <assignments v-if="selectedRepTab === 'ASSIGN'"></assignments>
    <scheduled-calls v-if="selectedRepTab === 'CA'"></scheduled-calls>
    <scheduled-calls-missed
      v-if="selectedRepTab === 'CA_MISSED'"
    ></scheduled-calls-missed>
    <questions v-if="selectedRepTab === 'QUEST'"></questions>
    <not-interested v-if="selectedRepTab === 'NI'"></not-interested>
    <not-interested-conversion
      v-if="selectedRepTab === 'NI_CONVERSION'"
    ></not-interested-conversion>
    <deposits-extended-report v-if="selectedRepTab === 'DEP'">
    </deposits-extended-report>
  </div>
</template>

<script>
import Campaigns from "../campaigns.reports/containers/Campaigns.container";
import Assignments from "../assignments.reports/containers/Assignments.container";
import ScheduledCalls from "../scheduled_calls.reports/containers/ScheduledCalls.container";
import Questions from "../questions.reports/containers/Questions.container";
import NotInterested from "../not_interested.reports/containers/NotInterested.container";
import DepositsExtendedReport from "../deposits.reports/conponents/DepositsExtendedReport.component";
import NotInterestedConversion from "../not_interested_conversion.reports/containers/NotInterestedConversion.container";
import ScheduledCallsMissed from "../scheduled_calls_missed.reports/containers/ScheduledCallsMissed.container";
export default {
  name: "Reports.container",

  components: {
    ScheduledCallsMissed,
    NotInterestedConversion,
    NotInterested,
    Campaigns,
    Assignments,
    ScheduledCalls,
    Questions,
    DepositsExtendedReport
  },
  data() {
    return {
      selectedRepTab: "CAMP",

      repTabs: [
        {
          id: 0,
          name: "CAMPAIGNS",
          alias: "CAMP"
        },
        {
          id: 1,
          name: "DEPOSITS",
          alias: "DEP"
        },
        // {
        //   id: 2,
        //   name: "DUPLICATES",
        //   alias: "DUP"
        // },
        {
          id: 3,
          name: "SCHEDULED CALLS",
          alias: "CA"
        },
        {
          id: 4,
          name: "SCHEDULED CALLS - MISSED",
          alias: "CA_MISSED"
        },
        {
          id: 5,
          name: "QUESTIONS",
          alias: "QUEST"
        },
        {
          id: 6,
          name: "ASSIGNMENTS",
          alias: "ASSIGN"
        },
        // {
        //   id: 7,
        //   name: "TRANSFERS",
        //   alias: "TRAN"
        // },
        // {
        //   id: 8,
        //   name: "REFERRALS",
        //   alias: "REF"
        // },
        // {
        //   id: 9,
        //   name: "NR",
        //   alias: "NR"
        // },
        {
          id: 10,
          name: "NI",
          alias: "NI"
        },
        {
          id: 11,
          name: "NI-conversion",
          alias: "NI_CONVERSION"
        }
        // {
        //   id: 12,
        //   name: "BN",
        //   alias: "BN"
        // },
        // {
        //   id: 13,
        //   name: "T4",
        //   alias: "T4"
        // }
      ]
    };
  }
};
</script>

<style scoped>
.root {
  width: 90%;
  margin: auto;
}
.card-body {
  padding: 10px;
}
.card-header {
  border-bottom: 1px solid rgba(10, 10, 10, 0.1);
}
.td-users-ms {
  width: 100px;
}
.floating-wrapper {
  position: relative;
}
.w50 {
  width: calc(50% - 0.2rem);
}
.left {
  float: left;
}
.margin {
  margin: 0.5rem;
}
.margin_r_hf {
  margin-right: 0.2rem;
}
.margin_l_c {
  margin-left: 0;
}
.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  overflow: hidden;
  height: max-content;
  min-width: 300px;
  position: absolute;
  margin: auto;
  top: 100px;
  right: 0;
  left: 0;
  width: 99%;
  font-family: Montserrat;
}

.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
          background: white;
        */
}
.style-nav.style2 li {
  /*border-radius: 5px 5px 0px 0px;*/
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 72px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(4px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
  /* transform: translateY(4px);*/
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.styleCardContent {
  background: white;
  min-height: 12rem;
  height: 100%;
}
.padding {
  padding: 1rem;
}
.form-body {
  padding: 20px;
  background-color: white;
}
.form-body form {
  margin-bottom: 20px;
}
.bttn {
  width: max-content;
  margin-top: 0.5rem;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  margin-left: 0.5rem;
}
.bttn-blue {
  background-color: #44a2d2;
}
.bttn-red {
  background-color: #dc3545;
}
.bttn-green {
  background-color: #28a745;
}
</style>
